import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ title, imagePath, gradient }) => (
  <Card
    sx={{
      position: "relative",
      height: "100%",
      borderRadius: 2,
      overflow: "hidden",
    }}
  >
    <CardMedia
      component="img"
      image={imagePath}
      alt={title}
      sx={{ height: "100%", width: "100%", objectFit: "cover" }}
    />
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: gradient,
        borderRadius: 0,
      }}
    />
    <CardContent
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        p: { xs: 2, sm: 3, md: 4 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        textAlign: "left",
      }}
    >
      <Typography
        variant="h4"
        component="h3"
        fontFamily="'Jost-Bold', Montserrat"
        fontWeight="bold"
        color="white"
        fontSize={{ xs: "24px", sm: "32px", md: "44px" }}
      >
        {title}
      </Typography>
      {/* <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography
          fontFamily="'Poppins-Regular', Helvetica"
          color="white"
          fontSize="20px"
        >
          Learn more
        </Typography>
        <Box
          component="img"
          src={learnMoreIcon}
          alt="Arrow"
          sx={{ ml: 1, width: "15px", height: "17px" }}
        />
      </Box> */}
    </CardContent>
  </Card>
);

const ServicesSection = () => {
  const navigate = useNavigate();
  const handleViewServicesClick = () => {
    navigate("/acs-services"); // Replace with your actual route
  };
  const services = [
    {
      id: 1,
      title: "DOCTOR CONSULTATION",
      imagePath: "/websiteAssets/LandingPageDoctorConsultant.png",
      gradient:
        "linear-gradient(180deg, rgba(217,217,217,0) 0%, rgba(4,4,4,0.8) 100%)",
    },
    {
      id: 2,
      title: "HOME NURSING",
      imagePath: "/websiteAssets/LandingPageHomeNursing.png",
      gradient:
        "linear-gradient(360deg, rgba(99,96,96,0) 0%, rgba(4,4,4,0.8) 100%)",
    },
    {
      id: 3,
      title: "MEDICINE DELIVERY",
      imagePath: "/websiteAssets/LandingPageMedicineDelivery.png",
      gradient:
        "linear-gradient(0deg, rgba(99,96,96,0) 0%, rgba(4,4,4,0.8) 100%)",
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "#1f164f",
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 12.5 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, md: 6.25 },
      }}
    >
      <Typography
        variant="h1"
        fontFamily="'Jost-Bold', Montserrat"
        fontWeight="bold"
        color="white"
        fontSize={{ xs: "36px", sm: "48px", md: "64px" }}
        letterSpacing={{ xs: "-2px", md: "-5px" }}
        align="center"
        sx={{ width: "100%", px: { xs: 2, md: 0 } }}
      >
        OUR SERVICES
      </Typography>

      <Grid
        container
        spacing={{ xs: 2.5, md: 3 }}
        sx={{
          maxWidth: "1240px",
          width: "100%",
          mx: "auto",
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            height: { xs: "auto", md: "504px" },
          }}
        >
          <Box
            sx={{
              height: { xs: 280, sm: 360, md: "100%" },
            }}
          >
            <ServiceCard {...services[0]} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={{ xs: 2.5, md: 3 }} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: { xs: 220, sm: 240, md: "50%" },
              }}
            >
              <ServiceCard {...services[1]} />
            </Box>
            <Box
              sx={{
                height: { xs: 220, sm: 240, md: "50%" },
              }}
            >
              <ServiceCard {...services[2]} />
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <Button
        variant="contained"
        color="primary"
        onClick={handleViewServicesClick}
        endIcon={<ArrowOutwardIcon />}
        sx={{
          bgcolor: "white",
          color: "#1f164f",
          borderRadius: "10px",
          px: { xs: 2, md: 3 },
          py: { xs: 1.25, md: 1.5 },
          textTransform: "none",
          fontFamily: "'Istok_Web-Bold', Montserrat",
          fontWeight: "bold",
          fontSize: { xs: 14, md: "16px" },
          "&:hover": {
            bgcolor: "white",
          },
        }}
      >
        View All Services
      </Button>
    </Box>
  );
};

export default ServicesSection;
